// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import moment from 'moment'

import {
  validateDateFormat,
  validateDateHasNotPassed,
  validateDateIsValid,
} from 'validators/common/sync/date'

const validateFutureDate = v => {
  const m = moment(v, 'YYYY/MM/DD')
  return (
    validateDateFormat(v) ||
    validateDateIsValid(m) ||
    validateDateHasNotPassed(m)
  )
}

export default validateFutureDate
